module.exports = __webpack_public_path__ + "static/media/icon-shown-pause.270da6cd.svg";